import axios from '../../../../../http.service';

const baseUrl = '/api/v2/release/postex6';

export const getTeams = async (year, apptTypes, query, selectors) => {
	let title = '';
	let markingTeamCode = '';
	let markingMethod = '';
	let apptType = '';

	if (selectors && selectors.length > 0)
	{
		let titleField = selectors.find(e => e.field == 'title');
		if (titleField)
		{
			title = titleField.value;
		}

		let markingTeamCodeField = selectors.find(e => e.field == 'markingTeamCode');
		if (markingTeamCodeField)
		{
			markingTeamCode = markingTeamCodeField.value;
		}

		let markingMethodField = selectors.find(e => e.field == 'markingMethod');
		if (markingMethodField)
		{
			markingMethod = markingMethodField.value;
		}

		let apptTypeField = selectors.find(e => e.field == 'type');
		if (apptTypeField)
		{
			apptType = apptTypeField.value;
		}
	}

	const url = `${baseUrl}/${year}/${JSON.stringify(apptTypes)}?pagination=${JSON.stringify(query)}&title=${title}&markingTeamCode=${markingTeamCode}&markingMethod=${markingMethod}&apptType=${apptType}`;
	const { status, data } = await axios.get(url);
	return { status, data };
};

export const getAppointees = async (year, apptType, markingTeamId, query) => {
	const url = `${baseUrl}/${markingTeamId}/${year}/${apptType}?pagination=${JSON.stringify(query)}`;
	const { status, data } = await axios.get(url);
	return { status, data };
};

export const updateAppointees = async updates => {
	const {
		status,
		data: { success, errors }
	} = await axios.put(baseUrl, { updates });
	return { status, success, errors };
};
